import React, { useState, useEffect } from 'react';
import './App.css';
import Welcome from './components/Welcome';
import QuestionFlow from './components/QuestionFlow';
import Summary from './components/Summary';
import { 
  initializeSession, 
  trackPageView, 
  trackBeginQuestions, 
  trackStartOver,
  trackSummaryPageReached
} from './utils/analytics';

function App() {
  const [currentPage, setCurrentPage] = useState('welcome');
  const [answers, setAnswers] = useState({});
  const [questionHistory, setQuestionHistory] = useState([]);
  
  // Initialize Google Analytics and session timing
  useEffect(() => {
    const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

    // Initialize session timing
    initializeSession();

    // Configure gtag if available and measurement ID is set
    if (GA_MEASUREMENT_ID && window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, []);
  
  // Track page views when currentPage changes
  useEffect(() => {
    trackPageView(currentPage);
  }, [currentPage]);
  
  const handleBegin = () => {
    trackBeginQuestions();
    setCurrentPage('questions');
  };

  const handleComplete = (finalAnswers, totalQuestions) => {
    setAnswers(finalAnswers);
    setCurrentPage('summary');
    
    // Track that user reached the final summary page
    const totalAnswers = Object.keys(finalAnswers).length;
    trackSummaryPageReached(totalAnswers, totalQuestions);
  };
  
  const handleGoBack = () => {
    if (currentPage === 'questions') {
      setCurrentPage('welcome');
    } else if (currentPage === 'summary') {
      setCurrentPage('questions');
    }
  };
  
  const handleStartOver = () => {
    const questionsAnswered = Object.keys(answers).length;
    trackStartOver(currentPage, questionsAnswered);
    setCurrentPage('welcome');
    setAnswers({});
    setQuestionHistory([]);
  };

  return (
    <div className="App">
      {currentPage === 'welcome' && (
        <Welcome onBegin={handleBegin} />
      )}
      
      {currentPage === 'questions' && (
        <QuestionFlow 
          onComplete={handleComplete} 
          onBack={handleGoBack}
          answers={answers}
          setAnswers={setAnswers}
          questionHistory={questionHistory}
          setQuestionHistory={setQuestionHistory}
        />
      )}
      
      {currentPage === 'summary' && (
        <Summary 
          finalAnswers={answers} 
          onStartOver={handleStartOver}
          onBack={handleGoBack}
        />
      )}
    </div>
  );
}

export default App;